import isWebview from 'is-ua-webview';

export type ClientContext = 'android' | 'ios' | 'webview' | 'browser' | 'server';

/**
 * Synchronous client context detection, mirroring the checks in getSDKStrategy().
 * Unlike sdk_version/nwap_version (populated asynchronously by the native SDK once it
 * calls ApiWebApp.info), this is resolved at event time so every analytics event carries
 * a reliable webview/browser signal.
 *
 * Kept in its own lightweight module (only depends on is-ua-webview) to avoid pulling the
 * MobileSdk dependency graph into the analytics layer, which would create a circular import.
 */
export function getClientContext(): ClientContext {
  if (typeof window === 'undefined') {
    return 'server';
  }
  if (window.CitiboxCourierSDK) {
    return 'android';
  }
  if (window.webkit?.messageHandlers) {
    return 'ios';
  }
  if (isWebview(window.navigator.userAgent)) {
    return 'webview';
  }
  return 'browser';
}
